import {
  ChargebeeComponentOptions,
  ChargebeePaymentComponentOptions,
} from '../../../types/chargebee';

const getComponentsOptions = (): ChargebeeComponentOptions => ({
  locale: 'en',
  style: {
    variables: {
      //   space2: '4px',
      space7: '46px',
      gray12: '#30313d',
      gray7: 'red',
      colorBackground: '#f4f4f8',
      defaultFontFamily:
        "-apple-system, 'system-ui', 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif",
    },
    rules: {
      section: {
        padding: '0px !important',
      },
      '.g-TextFieldRoot': {
        border: '1px solid rgb(230, 230, 230)',
        boxShadow: '0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 6px rgba(0, 0, 0, 0.02)',
        backgroundClip: 'padding-box',
        // '&:focus': {
        //   outline: 0,
        //   borderColor: 'hsla(210, 96%, 45%, 50%)',
        //   boxShadow: '0 0 0 3px hsla(210, 96%, 45%, 25%), 0 1px 1px 0 transparent',
        // },
      },
      // '#payment-container': {
      //   padding: '0px',
      // },
    },
  },
});

const getPaymentComponentOptions = (
  json: any,
  email?: string
): ChargebeePaymentComponentOptions => ({
  paymentIntent: json,
  layout: {
    type: 'tab',
    showRadioButtons: true,
  },
  paymentMethods: {
    sortOrder: ['card', 'paypal_express_checkout', 'google_pay', 'apple_pay'],
    allowed: ['apple_pay', 'paypal_express_checkout', 'card', 'google_pay'],
    // Suppresses Chargebee's built-in "I authorize ... to save this payment
    // method" text, which our legal-approved renewal disclaimer replaces
    // (ACDEV-26078). Chargebee renders that block only when the consent label
    // is non-empty, and it keeps retaining the payment method for recurring
    // payments regardless of this consent.
    savePaymentMethod: {
      label: '',
      consentType: 'consent',
      description: '',
      defaultChecked: false,
    },
  },
  form: {
    customer: {
      email: {
        required: true,
        placeholder: 'Email',
        label: 'Email',
        order: 1,
      },
    },
  },
  context: {
    customer: {
      email: email,
    },
  },
});

export const chargebeeUtils = { getPaymentComponentOptions, getComponentsOptions };
